import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";

/**
 * Floating Quick Exit — always available.
 * Tap = jump immediately to the calculator disguise route. From there, hold "="
 * for 1 second to return to Sister Signal.
 */
export default function QuickExitFAB() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // hide on calculator + onboarding + auth
  const hideOn = ["/calc", "/onboarding", "/auth", "/welcome"];
  if (hideOn.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <button
      data-testid="quick-exit-fab"
      onClick={() => navigate("/calc", { replace: true })}
      className="fixed top-4 right-4 z-50 inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-foreground/85 text-background text-xs font-medium shadow-md hover:opacity-100 opacity-90 transition-all"
      aria-label={t("quick_exit.label")}
      title={t("quick_exit.label")}
    >
      <LogOut className="w-3.5 h-3.5" />
      {t("quick_exit.label")}
    </button>
  );
}
